import React, { useContext, useEffect, useState } from 'react';
import dayjs from 'dayjs';

import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography'

import { CreateInvoice } from '../../billing/timesheets/ServiceInvoice';
import AuthContext from '../../../services/firebase/AuthContext';
import { download } from '../../../app/common/exports';
import FireDataContext from '../../../services/firebase/FireDataContext';
import InvoiceList from './InvoiceList';

const InvoiceContent = ({ invoiceType, title }) => {
    const db = useContext(FireDataContext);
    const { currentUser } = useContext(AuthContext);

    const [invoices, setInvoices] = useState([]);
    const [selection, setSelection] = useState();

    const handleDownload = () => {
        const header = `ID,Intermediary,Referrer,Booking,Invoice,Case,Invoice Date,Amount`;

        console.log('selection', selection);

        const contentlines = invoices
            .filter(({ id }) => !selection || selection.includes(id))
            .map(i => {
                const createdDate = dayjs(i.created.ts).format('YYYY-MM-DD');
                const member = i.intermediary.profile.title.replace(',', ' ').split(' ').slice(0, 2).join(' ');;
                //.split(' ').slice(0, 2).join(' ');

                return `${i.id},${member},${i.client.name.replace(',', '-')},${i.referral.bookingReference},${i.reference.toUpperCase()},${i.courtCase.courtCaseNumber},${createdDate},${i.doc.grandTotal()}`
            })

        const content = [header, ...contentlines].join('\n')

        download(`${invoiceType}-invoices.csv`, content, document);
    }

    useEffect(() => {
        const unsubscribe = [];

        (async () => {
            unsubscribe[0] = db.subscribe({
                path: `organizations/${currentUser.organizationId}/${invoiceType}_invoices`,
                hook: data => {
                    setInvoices(data
                        .filter(invoice => invoice.created?.user?.id === currentUser.uid || currentUser.roles?.includes('admin'))
                        .map(invoice => {
                            return {
                                ...invoice,
                                doc: CreateInvoice({ ...invoice.timesheet, invoiceType: invoice.invoiceType })
                            }
                        }));
                }
            });
        })();

        return unsubscribe[0];
    }, [db, currentUser, invoiceType]);

    return (
        <div>
            <Grid container spacing={1}>
                <Grid item>
                    <Typography variant="h6" color="initial">{title}</Typography>
                </Grid>
                <Grid item style={{ marginLeft: 'auto' }}>
                    <Tooltip title="Download" aria-label="download">
                        <IconButton onClick={handleDownload}>
                            <CloudDownloadIcon color="secondary" />
                        </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
            <InvoiceList invoices={invoices} invoiceType={invoiceType} onSelectionChange={({ selectionModel }) => setSelection(selectionModel)} />
        </div>
    );
};

export default InvoiceContent;